// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".satisfaction_summary_module-component {\n  padding: 24px;\n  background: var(--white);\n  border-radius: 10px;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); }\n  .satisfaction_summary_module-component .title-graph {\n    font-family: Catamaran;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 26px;\n    color: #7C878E;\n    margin-bottom: .7rem; }\n", ""]);
// Exports
module.exports = exports;
